// type RawDate = { year :: Int, month :: Int, day :: Int }
// foreign import parseRawDate :: forall r. r -> (RawDate -> r) -> String -> r
export function parseRawDate(onFailure) {
  return function (onSuccess) {
    return function (str) {
      const match = /^([0-9]{4,})-([0-9]{2})-([0-9]{2})$/.exec(str);
      if (!match) {
        return onFailure;
      }
      return onSuccess({
        year: parseInt(match[1], 10),
        month: parseInt(match[2], 10),
        day: parseInt(match[3], 10),
      });
    };
  };
}

// type RawDateTime = { year :: Int, month :: Int, day :: Int, hour :: Int, minute :: Int, second :: Int, millisecond :: Int }
// foreign import parseRawDateTime :: forall r. r -> (RawDateTime -> r) -> String -> r
export function parseRawDateTime(onFailure) {
  return function (onSuccess) {
    return function (str) {
      const re =
        /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(:([0-9]{2})([.]([0-9]?[0-9]?[0-9]?)[.]?[0-9]*)?)?(Z|\+0000)?$/;
      const match = re.exec(str);
      if (!match) {
        return onFailure;
      }
      return onSuccess({
        year: parseInt(match[1], 10),
        month: parseInt(match[2], 10),
        day: parseInt(match[3], 10),
        hour: parseInt(match[4], 10),
        minute: parseInt(match[5], 10),
        second: match[7] ? parseInt(match[7], 10) : 0,
        millisecond: match[9] ? parseInt(rightpad(3, match[9]), 10) : 0,
      });
    };
  };
}

// type RawTime = { hour :: Int, minute :: Int, second :: Int, millisecond :: Int }
// foreign import parseRawTime :: forall r. r -> (RawTime -> r) -> String -> r
export function parseRawTime(onFailure) {
  return function (onSuccess) {
    return function (str) {
      const re =
        /^([0-9]{2}):([0-9]{2})(:([0-9]{2})([.]([0-9]?[0-9]?[0-9]?)[.]?[0-9]*)?)?(Z|\+0000)?$/;
      const match = re.exec(str);
      if (!match) {
        return onFailure;
      }
      return onSuccess({
        hour: parseInt(match[1], 10),
        minute: parseInt(match[2], 10),
        second: match[4] ? parseInt(match[4], 10) : 0,
        millisecond: match[6] ? parseInt(rightpad(3, match[6]), 10) : 0,
      });
    };
  };
}

function rightpad(n, s) {
  while (s.length < n) {
    s += "0";
  }
  return s;
}
